import styles from "./styles.module.css";
import modalState from "../../../state-observables/modal/ModalState";
import Infographic from "../infographic.jpg";

function ColourSensorCalibrationInstructionsModal() {
  const onContinue = () => {
    modalState.closeModal();
  };

  return (
    <div className={styles.container}>
      <p>Marty's colour sensor(s) needs to be calibrated before you can use it. Please place Marty on a white surface and press Continue.</p>
      <div className={styles.infographic_container}>
        <img src={Infographic} alt="Infographic" className={styles.infographic} />
      </div>
      <div className={styles.buttonContainer}>
        <button className={styles.submitButton} onClick={onContinue}>
          Continue
        </button>
      </div>
    </div >
  );
}

export default ColourSensorCalibrationInstructionsModal;
